'use client';

import {
  useDisclosure,
  Box,
  Popover,
  PopoverTrigger,
  PopoverContent,
} from '@chakra-ui/react';
import { DesktopMenu } from '../header/DesktopMenu';
import { useCallback } from 'react';

interface HeaderMenuProps {
  menuTrigger: React.ReactNode;
  children?: React.ReactNode;

  /**
   * FOR USE IN PLASMIC STUDIO ONLY
   */
  menuOpenPreview?: boolean;
  loggedInPreview?: boolean;
}

export const HeaderMenu = ({
  menuTrigger,
  children,
  menuOpenPreview = true,
  loggedInPreview = true,
}: HeaderMenuProps) => {
  const {
    onOpen: onOpenMenu,
    isOpen: isMenuOpen,
    onClose: onCloseMenu,
  } = useDisclosure();

  const onMenuToggle = useCallback(() => {
    if (isMenuOpen) return onCloseMenu();
    return onOpenMenu();
  }, [isMenuOpen]);

  return (
    <Popover isOpen={isMenuOpen} onClose={onCloseMenu} placement="top-end">
      <PopoverTrigger>
        <Box cursor="pointer" onClick={onMenuToggle}>
          {menuTrigger}
        </Box>
      </PopoverTrigger>
      <PopoverContent
        boxShadow="lg"
        borderWidth="0"
      >
        <DesktopMenu isLoggedIn={loggedInPreview} onClose={onCloseMenu} />
      </PopoverContent>
    </Popover>
  );
};
